import AvaliaMaxPF from "./AvaliaMaxPF";
import AvaliaMaxPJ from "./AvaliaMaxPJ";
import AvaliaMaxPlusPJ from "./AvaliaMaxPlusPJ";
import AvaliaRiscoCompletaPositivoPJ from "./AvaliaRiscoCompletaPositivoPJ";
import AvaliaRiscoPF from "./AvaliaRiscoPF";
import AvaliaRiscoPJ from "./AvaliaRiscoPJ";
import CadastralPF from "./CadastralPF";
import CadastralPJ from "./CadastralPJ";
import ComportamentalPJ from "./ComportamentalPJ";
import ConcentracaoPagamentosPJQuery from "./ConcentracaoPagamentosPJQuery";
import ConcentracaoRecebimentoPJQuery from "./ConcentracaoRecebimentoPJQuery";
import FaturamentoPresumido from "./FaturamentoPresumido";
import GastoEstimadoPF from "./GastoEstimadoPF";
import GrauAtividade from "./GrauAtividade";
import HistoricoTransacionadoPJ from "./HistoricoTransacionadoPJ";
import LimiteCreditoPJ from "./LimiteCreditoPJ";
import LiquidezPagamentoPJQuery from "./LiquidezPagamentoPJQuery";
import LiquidezPJ from "./LiquidezPJ";
import LiquidezRecebimentoPJQuery from "./LiquidezRecebimentoPJQuery";
import MaisNegocioPJ from "./MaisNegocioPJ";
import MediaDiasInadimplenciaPJQuery from "./MediaDiasInadimplenciaPJQuery";
import PagamentosViaBoletoPJQuery from "./PagamentosViaBoletoPJQuery";
import PagamentosViaBoletoTedPJQuery from "./PagamentosViaBoletoTedPJQuery";
import PredicaoRecebimentoBoletoPJQuery from "./PredicaoRecebimentoBoletoPJQuery";
import ProtestoNacional from "./ProtestoNacional";
import RecebimentosViaBoletoPJQuery from "./RecebimentosViaBoletoPJQuery";
import RecebimentosViaBoletoTedCartaoPJQuery from "./RecebimentosViaBoletoTedCartaoPJQuery";
import RendaPresumidaPF from "./RendaPresumidaPF";
import RestritivaPF from "./RestritivaPF";
import RestritivaPJ from "./RestritivaPJ";
import ScoreBoletoPJ from "./ScoreBoletoPJ";
import ScoreEvolucaoPJ from "./ScoreEvolucaoPJQuery";
import ScorePF from "./ScorePF";
import ScorePJ from "./ScorePJ";
import SerasaPJ from "./SerasaPJ";

const Adicionais = ({ additionals, selectedQueries }) => {
  const renderComponent = (additional) => {
    const key = Object.keys(additional)[0];
    const value = additional[key];
    const limiteCreditoPj = additionals?.find(
      (item) => item.limiteCreditoPj
    )?.limiteCreditoPj;
    const maisNegocioPj = additionals?.find(
      (item) => item.limiteCreditoPj
    )?.maisNegocioPj;
    const faturamentoPresumidoPj = additionals?.find(
      (item) => item.faturamentoPresumidoPj
    )?.faturamentoPresumidoPj;
    const grauAtividadePj = additionals?.find(
      (item) => item.grauAtividadePj
    )?.grauAtividadePj;

    switch (key) {
      case "avaliaMaxPF":
        return <AvaliaMaxPF key={key} data={value} />;
      case "avaliaRiscoPF":
        return <AvaliaRiscoPF key={key} data={value} />;
      case "serasaPJ":
        return <SerasaPJ key={key} data={value} />;
      case "avaliaMaxPJ":
        return <AvaliaMaxPJ key={key} data={value} />;
      case "avaliaMaxPlusPJ":
        return <AvaliaMaxPlusPJ key={key} data={value} />;
      case "avaliaRiscoPJ":
        return <AvaliaRiscoPJ key={key} data={value} />;
      case "avaliaRiscoCompletaPositivaPJ":
        return (
          <AvaliaRiscoCompletaPositivoPJ
            key={key}
            data={value}
            selectedQueries={selectedQueries}
          />
        );
      case "rendaPresumidaPf":
        return <RendaPresumidaPF key={key} data={value} />;
      case "gastoEstimadoPf":
        return <GastoEstimadoPF key={key} data={value} />;
      case "scorePf":
        return <ScorePF key={key} data={value} />;
      case "cadastralPf":
        return <CadastralPF key={key} data={value} />;
      case "restritivaPf":
        return <RestritivaPF key={key} data={value} />;
      case "cadastralPj":
        return <CadastralPJ key={key} data={value} />;
      case "restritivaPj":
        return <RestritivaPJ key={key} data={value} />;
      case "comportamentalPj":
        return <ComportamentalPJ key={key} data={value} />;
      case "scorePj":
        return (
          <>
            <ScorePJ key={key} data={value} />
            {limiteCreditoPj && (
              <LimiteCreditoPJ key={key} data={limiteCreditoPj} />
            )}
            {maisNegocioPj && <MaisNegocioPJ key={key} data={maisNegocioPj} />}
            {faturamentoPresumidoPj && (
              <FaturamentoPresumido key={key} data={faturamentoPresumidoPj} />
            )}
            {grauAtividadePj && (
              <GrauAtividade key={key} data={grauAtividadePj} />
            )}
          </>
        );
      case "scoreBoletoPj":
        return (
          <>
            <ScoreBoletoPJ key={key} data={value} />
            {limiteCreditoPj && (
              <LimiteCreditoPJ key={key} data={limiteCreditoPj} />
            )}
            {maisNegocioPj && <MaisNegocioPJ key={key} data={maisNegocioPj} />}
            {faturamentoPresumidoPj && (
              <FaturamentoPresumido key={key} data={faturamentoPresumidoPj} />
            )}
            {grauAtividadePj && (
              <GrauAtividade key={key} data={grauAtividadePj} />
            )}
          </>
        );
      case "protestoNacional":
        return <ProtestoNacional key={key} data={value} />;
      case "recebimentosViaBoletoPJ":
        return (
          <RecebimentosViaBoletoPJQuery
            strategy="even"
            closedMonths={true}
            showTable={true}
            data={value}
          />
        );
      case "recebimentosViaBoletoTedCartaoPJ":
        return (
          <RecebimentosViaBoletoTedCartaoPJQuery
            strategy="even"
            closedMonths={true}
            showTable={true}
            data={value}
          />
        );
      case "pagamentosViaBoletoPJ":
        return (
          <PagamentosViaBoletoPJQuery
            strategy="even"
            closedMonths={true}
            showTable={true}
            data={value}
          />
        );
      case "pagamentosViaBoletoTedPJ":
        return (
          <PagamentosViaBoletoTedPJQuery
            strategy="even"
            closedMonths={true}
            showTable={true}
            data={value}
          />
        );
      case "predicaoRecebimentoBoletoPJ":
        return (
          <PredicaoRecebimentoBoletoPJQuery
            strategy="even"
            closedMonths={true}
            showTable={true}
            data={value}
          />
        );
      case "concentracaoRecebimentoPJ":
        return <ConcentracaoRecebimentoPJQuery data={value} />;
      case "concentracaoPagamentoPJ":
        return <ConcentracaoPagamentosPJQuery data={value} />;
      case "liquidezPagamentoPJ":
        return <LiquidezPagamentoPJQuery data={value} />;
      case "liquidezRecebimentoPJ":
        return <LiquidezRecebimentoPJQuery data={value} />;
      case "mediaDiasInadimpleciaPJ":
        return <MediaDiasInadimplenciaPJQuery data={value} />;
      case "scoreEvolucaoPJ":
        return <ScoreEvolucaoPJ data={value} />;

      default:
        return <></>;
    }
  };

  return <>{additionals?.map((additional) => renderComponent(additional))}</>;
};

export default Adicionais;
